import { render, staticRenderFns } from "./ContasReceberDetail.vue?vue&type=template&id=07261a7b&scoped=true"
import script from "./ContasReceberDetail.vue?vue&type=script&lang=js"
export * from "./ContasReceberDetail.vue?vue&type=script&lang=js"
import style0 from "./ContasReceberDetail.vue?vue&type=style&index=0&id=07261a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07261a7b",
  null
  
)

export default component.exports